import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon2: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm0 .91a9.09 9.09 0 1 0 0 18.18A9.09 9.09 0 1 0 10 .91Zm4.546 4.545c.25 0 .454.203.454.454v8.182a.455.455 0 0 1-.91 0v-3.636h-3.636v3.636a.455.455 0 0 1-.909 0v-3.636H5.91v3.636a.455.455 0 0 1-.909 0V5.909a.455.455 0 0 1 .91 0v3.636h3.635V5.91a.455.455 0 0 1 .91 0v3.636h3.636V5.91c0-.25.204-.454.455-.454Z"
      />
    </Svg>
  )
}
